// Müşteri kartı: aynı telefon / e-posta / Instagram ile verilmiş önceki oda teklifleri (saf fonksiyonlar).
// Müşteri tablosu yok; teklifler istemcide (DataContext) zaten var. Telefon son 10 haneyle eşleşir (text.js phoneKey).
import { phoneKey, emailKey, instagramKey } from './text';

// Eski kayıtlarda boş alana "-", "yok" gibi dolgu yazılmış: bunlar yüzlerce teklifle "aynı müşteri" sayılmasın
const realEmailKey = (value) => {
  const k = emailKey(value);
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(k) ? k : '';
};
const realInstagramKey = (value) => {
  const k = instagramKey(value);
  return /^[a-z0-9._]{3,30}$/.test(k) && /[a-z]/.test(k) ? k : '';
};

// who: { phone, email, instagram } → bu kişiye ait teklifler (yeniden eskiye). excludeId: düzenlenen teklifin kendisi.
export const customerOffers = (offers, who = {}, { excludeId } = {}) => {
  const p = phoneKey(who.phone);
  const e = realEmailKey(who.email);
  const i = realInstagramKey(who.instagram);
  if (!p && !e && !i) return [];
  return (offers || [])
    .filter((o) => o && String(o.id) !== String(excludeId ?? ''))
    .filter((o) => (p && phoneKey(o.phone) === p) || (e && realEmailKey(o.email) === e) || (i && realInstagramKey(o.instagram) === i))
    .sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));
};

// → { total, approved, rejected, pending, last } (last: en yeni teklif)
export const customerSummary = (list) => {
  const offers = list || [];
  const count = (status) => offers.filter((o) => o.status === status).length;
  return {
    total: offers.length,
    approved: count('Onaylandı'),
    rejected: count('Onaylanmadı'),
    pending: count('Onay Bekliyor'),
    last: offers[0] || null,
  };
};

// "4 teklif: 1 onaylı, 2 onaylanmadı, 1 bekliyor"
export const customerSummaryText = (s) => {
  if (!s || !s.total) return '';
  const parts = [];
  if (s.approved) parts.push(`${s.approved} onaylı`);
  if (s.rejected) parts.push(`${s.rejected} onaylanmadı`);
  if (s.pending) parts.push(`${s.pending} bekliyor`);
  return `${s.total} teklif${parts.length ? `: ${parts.join(', ')}` : ''}`;
};

// Listede "Tekrar müşteri" rozeti için: telefon/e-posta anahtarı başına teklif sayısı
export const repeatCustomerIndex = (offers) => {
  const counts = new Map();
  (offers || []).forEach((o) => {
    const keys = new Set([phoneKey(o.phone) && `p:${phoneKey(o.phone)}`, realEmailKey(o.email) && `e:${realEmailKey(o.email)}`].filter(Boolean));
    keys.forEach((k) => counts.set(k, (counts.get(k) || 0) + 1));
  });
  return (offer) => {
    const p = phoneKey(offer?.phone);
    const e = realEmailKey(offer?.email);
    return Math.max(p ? counts.get(`p:${p}`) || 0 : 0, e ? counts.get(`e:${e}`) || 0 : 0);
  };
};
